import { HiArrowNarrowRight } from "react-icons/hi";
import "../../styles/code/PotentialSection.css";

const cardData = [
  {
    image: "/images/code/potential/age-9-17.webp",
    title: "Chương trình Coding: lập trình cho trẻ 9 – 17 tuổi",
    link: "#",
  },
  {
    image: "/images/code/potential/age-4-17.webp",
    title:
      "Chương trình Digital Art & Design: Mỹ thuật số cho trẻ  4 – 17 tuổi",
    link: "#",
  },
  {
    image: "/images/code/potential/age-4-10.webp",
    title:
      "Chương trình Robotics: Lắp ráp và lập trình Robotics cho trẻ 4 – 10 tuổi",
    link: "#",
  },
];

function PotentialSection() {
  return (
    <section className="potential-section">
      <div className="potential-heading">
        <h2 className="potential-heading__text">
          <span className="potential-heading__highlight--age">
            Từ 4 đến 17 tuổi
          </span>
          <span className="potential-heading__normal">Khai phá</span>
          <span className="potential-heading__highlight">tiềm năng</span>
        </h2>
        <p className="potential-heading__description">
          Con có thiên hướng tư duy logic hay tư duy sáng tạo? Khám phá lộ trình
          phù hợp để con được trải nghiệm, bộc lộ và phát huy tối đa năng lực
          của mình.{" "}
        </p>
      </div>

      <div className="potential-section__cards">
        {cardData.map((card, index) => (
          <div
            className="potential-card"
            key={index}
          >
            <div className="potential-card__image">
              <img
                src={card.image}
                alt={card.title}
              />
            </div>
            <h3 className="potential-card__title">{card.title}</h3>
            <a
              href={card.link}
              className="potential-card__button"
            >
              <span className="potential-card__button-icon-wrapper">
                <HiArrowNarrowRight className="potential-card__button-icon" />
              </span>
              <span className="potential-card__button-text">Xem chi tiết</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PotentialSection;
